import React, { Fragment, useEffect, useRef, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Grid,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Typography,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import InterviewsApi from "../../utils/InterviewsApi"
import { FIELD_TYPES, capitalize, getMonthsAgo } from '../../utils/utils';
import JSTablePagination from '../JSTablePagination';
import LikeIcon from '@mui/icons-material/ThumbUpOutlined';
import LikedIcon from '@mui/icons-material/ThumbUpAlt';
import DislikeIcon from '@mui/icons-material/ThumbDownOutlined';
import DislikedIcon from '@mui/icons-material/ThumbDown';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';
import { Fields } from '../Fields';
import WorkIcon from '@mui/icons-material/Work';
import EventIcon from '@mui/icons-material/Event';
import SendIcon from '@mui/icons-material/Send';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';

import EditIcon from '@mui/icons-material/Edit';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';

const useStyles = makeStyles((theme) => ({
    headerPart:{
        [theme.breakpoints.up('sm')]: {
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'space-between',
            padding: 8,
            margin:'0 4px', 
        },
        [theme.breakpoints.down('sm')]: {
            margin: '8px 4px'
        }
    },
    searchContainer: {
        display: 'flex', 
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            gap: 8
        }
        
    }
}));

const isHebrew = (text = "") =>
  /[\u0590-\u05FF]/.test(text);

const truncateByWords = (text, maxWords) => {
    const words = text.trim().split(/\s+/);
    if (words.length <= maxWords) return text;
  
    return words.slice(0, maxWords).join(" ");
};

/*const ReadMoreCollapse = ({ text, collapsedHeight = 60 }) => {
    const [expanded, setExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const contentRef = useRef(null);
  
    useEffect(() => {
      if (contentRef.current) {
        const el = contentRef.current;
        // check if content height exceeds collapsed height
        setShowButton(el.scrollHeight > collapsedHeight);
      }
    }, [text, collapsedHeight]);

    const hebrew = isHebrew(text);

    let buttonCaption = ''

    if (hebrew){
        buttonCaption = expanded ? "הסתר" : "קרא עוד"
    } else {
        buttonCaption = expanded ? "Hide" : "Read more"
    }
  
    return (
        <>
            <Collapse in={expanded} collapsedSize={collapsedHeight}>
                <Typography dir="auto" ref={contentRef} style={{whiteSpace: 'pre-line', textAlign: 'justify', color: '#374151'}}>{text}</Typography>
            </Collapse>
    
            <div style={{textAlign: hebrew ? "right" : "left"}} >
                {showButton && !expanded && (
                    <Button
                        size="small"
                        color="primary"
                        style={{textTransform: 'lowercase', padding: '4px 0', minWidth: 'initial'}}
                        onClick={() => setExpanded(prev => !prev)}
                    >
                        {buttonCaption}
                    </Button>
                )}
            </div>
        </>
    );
};*/

function AddRwcapDialog(props){
    const open = props.open
    const [newData, setNewData] = useState({});
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState();
    const [added, setAdded] = useState(false);

    const handleClose = () => {
        setNewData({})
        setAdded(false)
        props.handleClose()
    }

    const handleSave = e => {
        e.preventDefault();

        setDisabled(true)
        setError()

        InterviewsApi.createInterviewRecap({params:newData, queryParams: props.queryParams},(response)=>{
            setDisabled(false)
            props.updateByResponse(response)
            setAdded(true)
        }, (error) => {
            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
            setDisabled(false)
        })
    }

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else {
            return defaultValue
        }
    }

    const handleChangeField = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    }

    const types = [
        {label:`Recruiter Call`},
        {label:`Self Application`},
        {label:`HR Interview`},
        {label:`Professional Interview`},
        {label:`Presentation Interview`},
        {label:`Technical Interview`},
        {label:`Home Assignment`},
        {label:`Linkedin Approach`},
        {label:`WhatsApp Approach`},
        {label:`Email Approach`},
    ]

    let askedQuestionPlaceholder = ''
    const type = getValue('type', '')
    
    if ([`Professional Interview`, `Presentation Interview`, `Technical Interview`, `Home Assignment`].includes(type)){
        askedQuestionPlaceholder = 'Enter technical questions you were asked\n' +
            'Copy paste the home assignment\n' +
            'Logic’s questions .., etc'
    }

    let fields = [
        {name:'company', label:'Company', defaultValue: '', type:FIELD_TYPES.TEXT, sm:12, required:true},
        {name:'title', label:'Professional Title', defaultValue: '' , type:FIELD_TYPES.TEXT, sm:12, required: true},
        {name:'type', label:'Interview Type', defaultValue: '', options:types, type:FIELD_TYPES.SELECT, required:true, sm:12},
        {name:'interviewDate', label:'Date', defaultValue: '', type:FIELD_TYPES.DATE2, required:true, sm:12},
        {name:'askedQuestions', label:'Professional / General Questions from interviews', defaultValue: '', type:FIELD_TYPES.MULTILINE, rows:2, required:true, rowsMax:8, sm:12, helperText: askedQuestionPlaceholder},
    ]

    return (
        <Dialog onClose={handleClose} open={open}>
            <DialogTitle>
                {added?'The Recap is added':'Add Recap'}
            </DialogTitle>
            {added?
                <DialogActions>
                    <Button disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Close">
                        Close
                    </Button>
                </DialogActions>:<form onSubmit={handleSave}>
                <DialogContent dividers>
                    {(error)&&<Typography color="error">{error}</Typography>}
                    <Fields fields={fields} getValue={getValue} handleChange={handleChangeField}/>
                </DialogContent>
                <DialogActions>
                    <Button disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Cancel">
                        Cancel
                    </Button>
                    <Button
                        disabled={disabled}
                        type="submit"
                        variant="outlined"
                        color="primary"
                        size="small"
                        aria-label='Save'
                    >
                        Save
                    </Button>
                </DialogActions>
            </form>}
        </Dialog>
    )
}

function InterviewRepliesDialog(props){
    const interview = props.interview || {}
    const queryParams = props.queryParams || {}

    const containerRef = useRef(null);

    const [newComment, setNewComment] = useState();
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState();

    const replies = interview.replies || []

    const handleChange = (event) => {
        setNewComment(event.target.value);
    };

    const handleAddComment = e => {
        e.preventDefault()

        setDisabled(true)
        setError()

        InterviewsApi.addInterviewCapReply({id: interview._id, newComment, queryParams},(response)=>{
            props.updateByResponse(response)
            setNewComment()

            const el = containerRef.current;
            if (el) {
                el.scrollTop = el.scrollHeight;
            }

            setDisabled(false)
        }, (error) => {
            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
            setDisabled(false)
        })
    }

    const handleClose = () => {
        setNewComment()
        props.handleClose()
    }

    return (
        <Dialog onClose={handleClose} open={interview._id !== undefined} maxWidth='md' fullWidth>
            <DialogTitle>
                <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <Typography variant='h4' style={{fontWeight: 700, fontSize: 20}}>{capitalize(interview.title)}{interview.company&&<> at {capitalize(interview.company)}</>}</Typography>
                    <IconButton disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Close">
                        <CloseIcon/>
                    </IconButton>
                </div>
            </DialogTitle>
            <DialogContent ref={containerRef}>
                {replies.map((reply) => <Fragment key={reply._id}>
                    <Typography dir="auto" style={{whiteSpace: 'pre-line', textAlign: 'justify', color: '#374151', margin: '8px 0'}}>
                        {reply.content}
                    </Typography>
                    <Divider/>
                </Fragment>)}
            </DialogContent>
            <DialogActions style={{display: 'block', justifyContent: 'initial', padding: '16px 24px'}}>
                <form onSubmit={handleAddComment}>
                    {(error)&&<Typography color="error" style={{marginBottom: 24}}>{error}</Typography>}
                    <div style={{display: 'flex',width: '100%', justifyContent: 'space-between', alignItems: 'center'}}>
                        <TextField 
                            InputProps={{
                                style: { borderRadius: 10 },
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            type="submit"
                                            color='primary'
                                            style={{paddingRight: 0}}
                                            disabled={disabled || !newComment}
                                            size="large">  
                                            <SendIcon fontSize="small" />
                                        </IconButton>
                                    </InputAdornment>
                                )
                            }}
                            value={newComment||''} placeholder='Add a comment...' variant="outlined" multiline fullWidth margin="none" size='small' onChange={handleChange}
                        />
                    </div>
                </form>
            </DialogActions>
        </Dialog>
    );
}

function InterviewRecap(props){
    const maxWords = 10
    const interview = props.interview || {}
    const text = interview.askedQuestions || ''
    const disabled = props.disabled || false
    const isAdmin = props.isAdmin || false
    const queryParams = props.queryParams || {}

    const handleLike = props.handleLike
    const handleDislike = props.handleDislike
    const handleComment = props.handleComment

    const [expanded, setExpanded] = useState(false);
    const [mode, setMode] = useState();
    const [error, setError] = useState();
    const [newContent, setNewContent] = useState(text);
    const [isSaving, setIsSaving] = useState(false);

    const hebrew = isHebrew(text);
    const words = text.trim().split(/\s+/);
    const isLong = words.length > maxWords;

    const displayedText = expanded ? text : truncateByWords(text, maxWords);

    const userReactions = interview.userReaction || []

    const isLiked = (userReactions.find(userReaction=>(userReaction.reactionType === "Like")) !== undefined)
    const isDisliked = (userReactions.find(userReaction=>(userReaction.reactionType === "Dislike")) !== undefined)

    const handleEdit = () => {
        setNewContent(text)
        setMode('edit')
    }

    const handleHide = () => {
        setMode('hide')
    }

    const handleCloseDialog = () => {
        setMode()
        setError()
    }

    const handlaeSave = e => {
        e.preventDefault() 

        setIsSaving(true)

        InterviewsApi.saveInterviewRecap({queryParams, id:interview._id, mode, newContent},(response)=>{
            props.updateByResponse(response)
            
            setIsSaving(false)
            handleCloseDialog()
        }, (error) => {
            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
            setIsSaving(false)
        })
    }

    const handleChangeContent = e => {
        setNewContent(e.target.value)        
    };

    const title = (interview.fromForum) ? interview.forumTitle : `${capitalize(interview.title)}${interview.company?(' at ' + capitalize(interview.company)):''}`
    
    return (
        <Paper style={{padding: 24, marginBottom: 24}}>
            <Dialog onClose={handleCloseDialog} open={(mode !== undefined)} fullWidth>
                <DialogTitle>
                    {(mode==='hide')&&<>Hide</>}
                    {(mode==='edit')&&<>Edit</>}
                </DialogTitle>
                <form onSubmit={handlaeSave}>
                    <DialogContent dividers>
                        {(error)&&<Typography color="error" style={{marginBottom: 24}}>{error}</Typography>}
                        {(mode==='hide')&&<Typography>Are you sure?</Typography>}
                        {(mode==='edit')&&<TextField variant='outlined' margin="none" multiline fullWidth required value={newContent} onChange={handleChangeContent} />}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            disabled={disabled || isSaving}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label={(mode==='hide')?'Yes':'Save'}
                        >
                            {(mode==='hide')?'Yes':'Save'}
                        </Button>
                        <Button disabled={disabled || isSaving} onClick={handleCloseDialog} color="primary" size="small" aria-label="Cancel">
                            {(mode==='hide')?'No':'Cancel'}
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>

            <Typography dir="auto" variant='h4' style={{fontWeight: 700, fontSize: 20, marginBottom: 8}}>{title}</Typography>
            <div style={{display: 'flex', marginBottom: 8}}>
                <Typography style={{fontSize: 14, color: '#4b5563', display: 'flex', alignItems: 'center'}}><EventIcon style={{marginRight:8}}/>{getMonthsAgo(new Date(interview.interviewDate))}</Typography>
                {interview.type&&<Typography style={{fontSize: 14, color: '#4b5563', display: 'flex', alignItems: 'center', marginLeft: 16}}><WorkIcon style={{marginRight:8}}/>{capitalize(interview.type)}</Typography>}
            </div>
            <Typography dir="auto" style={{whiteSpace: 'pre-line', textAlign: 'justify', color: '#374151'}}>
                {displayedText}
                {isLong && !expanded && (
                    <>
                        <span>...</span>
                        <span onClick={() => setExpanded(prev => !prev)} style={{marginLeft: 4, cursor: 'pointer', color: 'blue'}}>
                            {expanded
                                ? hebrew ? "קרא פחות" : "Read less"
                                : hebrew ? "קרא עוד" : "read more"}
                        </span>
                    </>
                )}
            </Typography>
            <div style={{display:'flex', alignItems: 'center', paddingTop: 16, marginTop: 16, borderTop: '1px solid #e0e0e0'}}>
                <IconButton size='small' disabled={disabled || isDisliked} color='primary' onClick={()=>handleLike(interview._id)} style={{paddingLeft: 0}}>
                    {isLiked ? <LikedIcon  fontSize='small'/> : <LikeIcon fontSize='small'/>}
                </IconButton>
                <Typography style={{marginLeft: 4}}>{interview.likes}</Typography>
                <IconButton size='small' disabled={disabled || isLiked} color='primary' onClick={()=>handleDislike(interview._id)} style={{marginLeft: 16}}>
                    {isDisliked ? <DislikedIcon fontSize='small'/> : <DislikeIcon fontSize='small'/>}
                </IconButton>
                <Typography style={{marginLeft: 4}}>{interview.dislikes}</Typography>
                <Button size='small' disabled={disabled} color='primary' onClick={()=>handleComment(interview)} style={{marginLeft: 16, textTransform: 'none', fontSize: 16}}>
                    <ChatOutlinedIcon fontSize='small' style={{marginRight:4}}/>
                    {interview.replies.length} comments
                </Button>
                {isAdmin&&<>
                    <div style={{flex:1}}></div>
                    <IconButton
                        style={{marginRight: 8}}
                        disabled={disabled || isDisliked}
                        onClick={handleEdit}
                        color='primary'
                        size="large">
                        <EditIcon  fontSize='small'/>
                    </IconButton>
                    <IconButton
                        disabled={disabled || isDisliked}
                        onClick={handleHide}
                        color='primary'
                        size="large">
                        <VisibilityOffIcon  fontSize='small'/>
                    </IconButton>
                </>}
            </div>
        </Paper>
    );
}

function SearchPart(props){
    const searchFields = props.searchFields || {}

    const isMobile = (window.innerWidth <= 768)

    const [newSearch, setNewSearch] = useState({...searchFields});

    const [expanded, setExpanded] = useState(!isMobile);

    const getValue = name => {
        if (newSearch[name] !== undefined){
            return newSearch[name]
        } else {
            return searchFields[name] || ''
        }
    }

    const handleChangeField = e => {
        setNewSearch({...newSearch,[e.target.name]: e.target.value})
    };

    const handleSearch = () => {
        props.setSearchFields({...newSearch})
        if (isMobile){
            setExpanded(false)
        }
    }

    const classes = useStyles();

    return (
        <>
            {expanded?<div className={classes.searchContainer}>
                <TextField
                    name='company'
                    type="search"
                    value={getValue('company')}
                    onChange={handleChangeField}
                    placeholder="Company"
                    variant="outlined"
                    style={{marginRight:8, width: '100%'}}
                    size='small'
                    onKeyPress={event => {
                        if (event.key === 'Enter') {
                            handleSearch();
                        }
                    }}
                />
                <TextField
                    name='title'
                    type="search"
                    value={getValue('title')}
                    onChange={handleChangeField}
                    placeholder='Title'
                    variant="outlined"
                    style={{marginRight:8, width: '100%'}}
                    size='small'
                    onKeyPress={event => {
                        if (event.key === 'Enter') {
                            handleSearch();
                        }
                    }}
                />
                <Button variant="contained" color="primary" onClick={handleSearch} aria-label="Search" size='small'>
                    Search
                </Button>
            </div>:
            <Paper elevation={1} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <div style={{padding: 8, overflow: 'hidden'}} onClick={()=>setExpanded(true)}>
                    <Typography color={searchFields.company?'textPrimary':'textSecondary'}>{searchFields.company||'Company'}</Typography>
                    <Typography color={searchFields.title?'textPrimary':'textSecondary'}>{searchFields.title||'Title'}</Typography>
                </div>
                <div>
                    <IconButton color='primary' onClick={handleSearch} aria-label="Search" size="large">
                        <SearchIcon/>
                    </IconButton>
                </div>
            </Paper>}
        </>
    );
}

function DialogForInterviews(props){
    const isAuthed = props.isAuthed || false
    const isDeleteDialog = props.isDeleteDialog || false
    const dialogData = props.dialogData || false
    const disabled = props.disabled || false
    const error = props.error
    const dialogTitle = props.dialogTitle

    const [newData, setNewData] = useState({});
    const [randoms, setRandoms] = useState([Math.floor(Math.random() * 99) + 1, Math.floor(Math.random() * 99) + 1, Math.floor(Math.random() * 2)]);

    useEffect(() => {
        setRandoms([Math.floor(Math.random() * 99) + 1, Math.floor(Math.random() * 99) + 1, Math.floor(Math.random() * 2)])
        setNewData({})
    }, [dialogData]);

    const saveDialog = e => {
        e.preventDefault() 

        if (dialogData.cbFunc){
            dialogData.cbFunc(dialogData.id, randoms, newData)
        }
    }

    const getValue = (name, defaultValue) => {
        if (newData[name] !== undefined){
            return newData[name]
        } else {
            return defaultValue
        }
    }

    const handleChange = e => {
        setNewData({...newData,[e.target.name]: e.target.value})
    };

    const handleClose = () => {
        props.setDialogData({})
    }

    const fields = []

    const question = 'What number is ' + (randoms[2]===0?'bigger ':'smaller ') + (randoms[0]) + ' or ' + ((randoms[1]===randoms[0])?randoms[1]+1:randoms[1])

    return (
        <Dialog onClose={handleClose} open={dialogData.id !== undefined}>
            <div style={{maxWidth:1200, width:'100%', margin:'0 auto'}}>
            {dialogTitle&&<DialogTitle>{dialogTitle}</DialogTitle>}
                <form onSubmit={saveDialog}>
                    <DialogContent dividers>
                        {(error)&&<Typography color="error" style={{marginBottom: 24}}>{error}</Typography>}
                        {(isDeleteDialog)?<Typography>Are you sure?</Typography>:
                        <Fields fields={fields} getValue={getValue} handleChange={handleChange}/>}
                        {(!isAuthed)&&<Grid container spacing={1}>
                            <Grid item sm={12} xs={12}>
                                <TextField
                                    variant="standard"
                                    name="validate"
                                    label={question}
                                    margin="none"
                                    fullWidth
                                    required
                                    value={getValue('validate', '')}
                                    onChange={handleChange}
                                    helperText={'This question is a means of preventing forms from being automatically submitted by spam bots.'} />
                            </Grid>
                        </Grid>}
                    </DialogContent>
                    <DialogActions style={{justifyContent: 'flex-start', padding: '8px 24px'}}>
                        <Button
                            disabled={disabled}
                            type="submit"
                            variant="outlined"
                            color="primary"
                            size="small"
                            aria-label={isDeleteDialog?'Yes':'Save'}
                        >
                            {isDeleteDialog?'Yes':'Save'}
                        </Button>
                        <Button disabled={disabled} onClick={handleClose} color="primary" size="small" aria-label="Cancel">
                            Cancel
                        </Button>
                    </DialogActions>
                </form>
            </div>
        </Dialog>
    );
}

export default function Newinterviews(props) {
    const isAuthed = props.isAuthed || false
    const isAdmin = props.isAdmin || false

    const [searchFields, setSearchFields] = useState({});
    const [disabled, setDisabled] = useState(false);
    const [error, setError] = useState();
    const [interviews, setInterviews] = useState([]);
    const [count, setCount] = useState(22);
    const [page, setPage] = useState(0);
    const [dialogData, setDialogData] = useState({});
    const [interviewToShow, setinterviewToShow] = useState();
    const [showAddRecap, setShowAddRecap] = useState(false);

    useEffect(() => {
        setDisabled(true)

        InterviewsApi.getInterviewsNew({queryParams:{...searchFields, page}},(response)=>{
            updateByResponse(response)
            
            setDisabled(false)
        }, (error) => {
            console.log(error)
            setDisabled(false)
            setError(error)
        })
    }, [searchFields, page, isAuthed]);

    const updateByResponse = (response={}) => {
        setInterviews(response.interviews || [])
        setCount(response.count || 0)

        if (response.interview){
            setinterviewToShow(response.interview)
        }
    }

    const handleChangePage = (newPage) => {
        setPage(newPage);
    };

    const handleChangeSearchFileds = newSearchFields => {
        setSearchFields(newSearchFields)
        setPage(0)
    }

    const handleLike = id => {
        if (!isAuthed){
            setDialogData({id:id, cbFunc: toggleLike})
        } else {
            toggleLike(id)
        }
    }

    const handleDislike = id => {
        if (!isAuthed){
            setDialogData({id:id, cbFunc: toggleDislike})
        } else {
            toggleDislike(id)
        }
    }

    const handleComment = interview => {
        setinterviewToShow(interview)
    }

    const toggleLike = (id, randoms, newData) => {
        setDisabled(true)

        InterviewsApi.toggleReactionInterview({queryParams:{...searchFields, page}, id, randoms, ...newData, reaction: 'Like'},(response)=>{
            updateByResponse(response)
            
            setDialogData({})
            setDisabled(false)
        }, (error) => {
            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
            setDisabled(false)
        })
    }

    const toggleDislike = (id, randoms, newData) => {
        setDisabled(true)

        InterviewsApi.toggleReactionInterview({queryParams:{...searchFields, page}, id, randoms, ...newData, reaction: 'Dislike'},(response)=>{
            updateByResponse(response)
            
            setDialogData({})
            setDisabled(false)
        }, (error) => {
            if(error&&error.response&&error.response.data){
                setError(error.response.data)
            } else {
                setError('Something went wrong')
            }
            setDisabled(false)
        })
    }

    const classes = useStyles();

    return (
        <div style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
            <AddRwcapDialog queryParams={{...searchFields, page}} open={showAddRecap} handleClose={()=>setShowAddRecap(false)} updateByResponse={updateByResponse}/>

            <DialogForInterviews isAuthed={isAuthed} error={error} disabled={disabled} dialogData={dialogData} setDialogData={setDialogData}/>

            <InterviewRepliesDialog queryParams={{...searchFields, page}} disabled={disabled} interview={interviewToShow} handleClose={()=>setinterviewToShow()} updateByResponse={updateByResponse}/>

            <div className={classes.headerPart}>
                <div>
                    <div style={{display: 'flex', alignItems: 'center', gap: 16}}>
                        <Typography variant='h2' style={{fontWeight: 700, fontSize: 30, marginBottom: 8}}>Interview Recaps</Typography>
                    </div>
                    <Typography style={{color: '#4b5563'}}>Learn from real interview experiences shared by the community<br/>You can search for a specific company, or by a title</Typography>
                </div>
                <div>
                    <SearchPart searchFields={searchFields} setSearchFields={handleChangeSearchFileds}/>
                    <div style={{textAlign:'center'}}>
                        <Button style={{marginTop: 16, marginRight: 72, textTransform: 'none'}} variant='contained' color='primary' onClick={()=>setShowAddRecap(true)}>+ Add Recap</Button>
                    </div>
                </div>
            </div>
            <div style={{margin:'2px 4px', flex: 1, overflow: 'auto'}}>
                {interviews.map((interview) => <InterviewRecap 
                    key={interview._id} 
                    isAdmin={isAdmin} 
                    interview={interview} 
                    disabled={disabled} 
                    handleLike={handleLike} 
                    handleDislike={handleDislike} 
                    handleComment={handleComment} 
                    updateByResponse={updateByResponse} 
                    queryParams={{...searchFields, page}}
                />)}
            </div>
            <div style={{margin:'0 4px'}}>
                <JSTablePagination
                    count={count}
                    rowsPerPage={25}
                    page={page}
                    onChangePage={handleChangePage}
                    disabled={disabled}
                >
                    <div></div>
                </JSTablePagination>
            </div>
        </div>
    )
}